import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Root as LabelPrimitive } from '@radix-ui/react-label';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';
const labelVariants = cva('text-sm font-medium leading-none mb-1 peer-disabled:cursor-not-allowed peer-disabled:opacity-70');
const Label = React.forwardRef(({ className, ...props }, ref) => (_jsx(LabelPrimitive, { ref: ref, className: cn(labelVariants(), className), ...props })));
Label.displayName = LabelPrimitive.displayName;
export { Label };
//# sourceMappingURL=label.js.map